import { useState, type ReactNode } from 'react';

import type { AuthUser } from '@/modules/auth/types';
import { PortalHeader } from '@/shared/layout/PortalHeader';
import { PortalPageContent } from '@/shared/layout/PortalPageContent';
import { PortalSidebar } from '@/shared/layout/PortalSidebar';

interface PortalShellProps {
  user: AuthUser;
  children: ReactNode;
}

export function PortalShell({ user, children }: PortalShellProps) {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className="portal-shell">
      <div className="flex min-h-screen">
        <PortalSidebar mobileOpen={mobileNavOpen} onClose={() => setMobileNavOpen(false)} />
        <div className="flex min-w-0 flex-1 flex-col">
          <PortalHeader user={user} onMenuClick={() => setMobileNavOpen(true)} />
          <main className="flex-1 overflow-auto px-4 py-6 sm:px-6 sm:py-8 md:px-8">
            <PortalPageContent>{children}</PortalPageContent>
          </main>
        </div>
      </div>
    </div>
  );
}
